import * as React from "react";
const SvgFiBrandsMeta = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-meta_svg__a)">
      <path
        fill="#151A2D"
        d="M17.943 4.026c-2.05 0-3.652 1.482-5.103 3.365-1.994-2.437-3.66-3.365-5.656-3.365C3.117 4.026 0 9.106 0 14.486c0 3.366 1.696 5.489 4.538 5.489 2.044 0 3.515-.925 6.13-5.313l1.84-3.12q.393.61.83 1.316l1.226 1.98c2.388 3.836 3.718 5.137 6.13 5.137 2.768 0 4.308-2.152 4.308-5.588C25 8.755 21.814 4.026 17.942 4.026m-9.27 9.448c-2.12 3.19-2.853 3.905-4.033 3.905-1.215 0-1.937-1.024-1.937-2.85 0-3.904 2.028-7.896 4.446-7.896 1.31 0 2.403.726 4.08 3.029-1.591 2.342-2.556 3.812-2.556 3.812m12.076 3.905c-1.207 0-1.784-.765-4.076-4.306l-1.466-2.347a49 49 0 0 0-1.144-1.71c1.321-1.957 2.411-2.933 3.708-2.933 2.692 0 4.847 3.806 4.847 8.48-.001 1.782-.609 2.816-1.869 2.816"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-meta_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsMeta;
